var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import ButtonLoader from '../../../../components/ButtonLoader';

var Button = function Button(_ref) {
  var isLoading = _ref.isLoading,
      className = _ref.className,
      children = _ref.children,
      others = _objectWithoutProperties(_ref, ['isLoading', 'className', 'children']);

  return React.createElement(
    'button',
    _extends({}, others, { className: '' + className + (isLoading ? ' loading' : '') }),
    isLoading && React.createElement(ButtonLoader, null),
    children
  );
};

export default Button;